// removed by extract-text-webpack-plugin
module.exports = {"Dialog":"uBJ9KcfLW7x9-Th2B1kYi","MyDrawer":"_1ZY8Rhkts2PpJYznY-0We6"};


//////////////////
// WEBPACK FOOTER
// ./src/utils/FunctionalDialog/index.less
// module id = 418
// module chunks = 7